export default __webpack_public_path__ + "static/media/SL 2BR Park Model Dlx.8ecb5cdb.jpg";